import script from "./Krediflow-Settings.vue?vue&type=script&setup=true&lang=js"
export * from "./Krediflow-Settings.vue?vue&type=script&setup=true&lang=js"

import "./Krediflow-Settings.vue?vue&type=style&index=0&id=b633026a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b633026a"]])

export default __exports__